export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_11210_COACH_ASSIST_SUMMARY': 'Coach Assist Summary',
    '_9488_ADD_COMMITMENT_NOTE': 'Add Commitment Note',
    '_11032_ADD_OBSERVATION_NOTE': 'Add Observation Note'
};
